export default __webpack_public_path__ + "static/media/info512.352f0ac0.png";